import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
// Components
import Tooltip from 'rc-tooltip';
import Avatar from 'react-avatar';
// Helpers
import {getLastOnlineLabel} from '../../../../../helpers/dateTime';
import {getAvatarInitials, getAvatarBackgroundColor} from '../../../../../helpers/avatar';
// Styles
import './user-list-item.scss';
import TextOverflowTooltip from '../../../../common/TextOverflowTooltip';

class UserListItem extends PureComponent {
  render() {
    return (
      <div className="glu-content__section glu-content__separator glu-content__separator--inner">
        <div className="user-list-item-wrapper">
          <div>
            {this.props.userDetails.image ? (
              <img className="glu-widget__image" src={this.props.userDetails.image} alt="avatar" />
            ) : (
              <Avatar
                name={getAvatarInitials(
                  this.props.userDetails.firstName,
                  this.props.userDetails.lastName
                )}
                color={getAvatarBackgroundColor(
                  this.props.userDetails.firstName,
                  this.props.userDetails.lastName
                )}
                round
                size="80px"
              />
            )}
          </div>
          <div className="user-details">
            <div className="name-role-send-email">
              <div className="name-and-role">
                <div className="name">
                  {`${this.props.userDetails.firstName} ${this.props.userDetails.lastName}`}
                </div>
                <div className="role">{this.props.userDetails.role}</div>
              </div>
              <Tooltip placement="top" trigger={['hover']} overlay={<span>Send Email</span>}>
                <a className="email-link" href={`mailto:${this.props.userDetails.email}`}>
                  <span className="g-icon g-icon-mail" />
                </a>
              </Tooltip>
            </div>
            <div className="glu-flex-col glu-flex-justify-end online-status-and-solution">
              <div className={this.props.userDetails.loggedIn ? 'status-online' : ''}>
                {this.props.userDetails.loggedIn
                  ? 'Online'
                  : `Last logged in: ${getLastOnlineLabel(this.props.userDetails.lastLoggedIn)}`}
              </div>
              <div>{`Solution used: ${this.props.userDetails.lastSolution || '-'}`}</div>
              <TextOverflowTooltip
                title={this.props.userDetails.organization}
                height={this.props.height}
                width={this.props.width}
                renderChildren={(ref) => (
                  <div className="glu-flex-grow">
                    <div className="organization-used" ref={ref}>
                      {`Organization used: ${this.props.userDetails.organization || '-'}`}
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserListItem.propTypes = {
  userDetails: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default UserListItem;
